import axios from 'axios';
import cfg from '../config.json';
import _, { cloneDeep } from 'lodash';
import Moment from 'moment';

import BranchHeadCount from '../models/branchHeadCount';

import { showLoading, showInfo, showErrorResponse, clearMsg } from './msgReducer';

//================== Whole State ==================//
//let initialCalDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
//initialCalDate.setMonth(initialCalDate.getMonth() - 1);

const initialState = {
  isInited: false,
  isLoading: false,
  isFilterUpdated: false,
  filter: { // match EntitiesResult<T>
    allRecords: 0,
    matchedRecords: 0,
    totalRecords: 0,
    qtyPerPage: 100,
    page: 1,
    row: 0,
    //filter: JSON.stringify([{ "property": "cal_date", "value": initialCalDate }]),
    filter: "[]",
    sort: JSON.stringify([{ "property": "fdate", "direction": "DESC" }]),
    success: true,
    message: '',
  },
  entities: [],
  workingEntityId: -1,
  workingEntities: [],
  errors: '',
};


//================== Action Types ==================//
export const BranchHeadCountActions = Object.freeze({
  // filter
  FILTER_UPDATE: Symbol("FILTER_UPDATE"),
  CHANGE_SORT: Symbol("CHANGE_SORT"),
  PAGE_UPDATE: Symbol("PAGE_UPDATE"),
  FETCH_PAGE: Symbol("FETCH_PAGE"),

  // listing
  REQUEST: Symbol("REQUEST"),
  SUCCESS: Symbol("SUCCESS"),
  FAILURE: Symbol("FAILURE"),

  // detail page
  DETAIL_ID: Symbol("DETAIL_ID"),
  DETAIL_SUCCESS: Symbol("DETAIL_SUCCESS"), // ajax loaded
  DETAIL_FAILURE: Symbol("DETAIL_FAILURE"),

  DETAIL_UPDATE: Symbol("DETAIL_UPDATE"), // form fields update
  DETAIL_DELETED: Symbol("DETAIL_DELETED"), // ajax delete

  DETAILS_INIT: Symbol("DETAILS_INIT"), // for calDate
});


//================== Action Creators ==================//
export const branchHeadCountFilterUpdate = (field, value) => {
  return {
    type: BranchHeadCountActions.FILTER_UPDATE,
    payload: {
      field: field,
      value: value
    }
  }
}

const _setWorkingEntityId = (id) => {
  return {
    type: BranchHeadCountActions.DETAIL_ID,
    payload: id,
  }
}

export const branchHeadCountFilterClear = () => {
  return (dispatch) => {
    dispatch(_setWorkingEntityId(initialState.workingEntityId));
    dispatch(branchHeadCountLookup(initialState.filter));
  }
}

export const branchHeadCountChangeSort = (field) => {
  return (dispatch, getState) => {
    dispatch({
      type: BranchHeadCountActions.CHANGE_SORT,
      payload: field,
    });
    const { branchHeadCount: { filter } } = getState(); // state updated
    //console.log(filter);
    dispatch(branchHeadCountLookup(filter));
  };
}

export const branchHeadCountPageUpdate = (page) => {
  return (dispatch, getState) => {
    const { branchHeadCount: { filter } } = getState(); // state updated

    let _page = 1;

    if (page == "") {
      _page = "";
    } else {
      _page = parseInt(page);
      if (_.isNaN(_page)) return;
      if (_page < 1) _page = 1;
      if (_page > Math.ceil(filter.matchedRecords / filter.qtyPerPage)) _page = Math.ceil(filter.matchedRecords / filter.qtyPerPage);
    }

    dispatch({
      type: BranchHeadCountActions.FETCH_PAGE,
      payload: _page,
    });
  };
}

export const branchHeadCountFetchPage = (page) => {
  return (dispatch, getState) => {
    dispatch({
      type: BranchHeadCountActions.FETCH_PAGE,
      payload: page,
    });
    const { branchHeadCount: { filter } } = getState(); // state updated
    //console.log(filter);
    dispatch(branchHeadCountLookup(filter));
  };
}

const _branchHeadCountRequest = () => {
  return {
    type: BranchHeadCountActions.REQUEST
  }
}

const _branchHeadCountSuccess = (data) => {
  return {
    type: BranchHeadCountActions.SUCCESS,
    payload: data,
  }
}

const _branchHeadCountFailure = (response) => {
  return {
    type: BranchHeadCountActions.FAILURE,
    payload: response,
  }
}

export const branchHeadCountLookup = (formData) => {
  const _formData = formData ? formData : initialState.filter;
  //console.log(_formData);
  const apiEndpoint = `${cfg.ApiOrigin == "window.location.origin" ? window.location.origin : cfg.ApiOrigin}/api/BranchHeadCount/GetEntities`;

  return (dispatch, getState) => {
    dispatch(_branchHeadCountRequest());

    const { branchHeadCount } = getState(); // state updated
    if (branchHeadCount.isFilterUpdated) _formData.page = 1; // reset page if filter changed
    if (branchHeadCount.filter.page == "") _formData.page = 1; // reset page if filter changed

    axios.post(apiEndpoint, _formData, {
      timeout: 30000,
    })
      .then(response => {
        if (response.data) {
          dispatch(_branchHeadCountSuccess(response.data));
        } else {
          dispatch(_branchHeadCountFailure("未能讀取"));
        }
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.errors) {
          dispatch(_branchHeadCountFailure(error.response.data.errors));
        } else if (error.response && error.response.status) {
          dispatch(_branchHeadCountFailure(`未能讀取 (${error.response.status})`));
        } else {
          dispatch(_branchHeadCountFailure(`未能聯繫伺服器`));
        }
      })
  }
}

const _branchHeadCountDetailSuccess = (data) => {
  return {
    type: BranchHeadCountActions.DETAIL_SUCCESS,
    payload: data,
  }
}

const _branchHeadCountDetailFailure = (response) => {
  return (dispatch, getState) => {
    dispatch({
      type: BranchHeadCountActions.DETAIL_FAILURE,
      payload: response,
    })
  }
}

export const branchHeadCountDetails = (Id, isForce) => {
  return (dispatch, getState) => {
    const { branchHeadCount: { workingEntityId: lastWorkingEntityId } } = getState();
    if (!isForce && lastWorkingEntityId == Id) return; // same entity

    dispatch(_setWorkingEntityId(Id)); // 任何 dispatch 之前先記住 current working entity id, 因為 dispatch 之後會再行 useEffect，喺上一句就 quit 咗

    const apiEndpoint = `${cfg.ApiOrigin == "window.location.origin" ? window.location.origin : cfg.ApiOrigin}/api/BranchHeadCount/GetSameMonthEntities`;

    dispatch(_branchHeadCountRequest());

    axios.post(apiEndpoint, { Id }, {
      timeout: 30000,
    })
      .then(response => {
        dispatch(clearMsg());

        if (response.data) {
          dispatch(_branchHeadCountDetailSuccess(response.data));
        } else {
          dispatch(_branchHeadCountDetailFailure("未能讀取"));
        }
      })
      .catch(error => {
        dispatch(_branchHeadCountDetailFailure("未能讀取"));
        dispatch(showErrorResponse(error));
      })
  };
}

export const branchHeadCountDetailUpdate = (index, fieldName, value) => {
  return {
    type: BranchHeadCountActions.DETAIL_UPDATE,
    payload: { index, fieldName, value },
  }
}

export const branchHeadCountDetailsInit = (calDate) => {
  return {
    type: BranchHeadCountActions.DETAILS_INIT,
    payload: calDate
  }
}

export const saveEntities = (history) => {
  return (dispatch, getState) => {
    const apiEndpoint = `${cfg.ApiOrigin == "window.location.origin" ? window.location.origin : cfg.ApiOrigin}/api/BranchHeadCount/SaveEntities`;

    const { branchHeadCount: { workingEntities } } = getState();

    dispatch(showLoading());

    axios.post(apiEndpoint, workingEntities, {
      timeout: 30000,
    })
      .then(response => {
        if (history.location.pathname == "/branchHeadCountDetails/0") {
          history.replace(`/branchHeadCountDetails/${response.data[0].Id}`);
          dispatch(showInfo("已保存"));
          return;
        }

        dispatch(_branchHeadCountDetailSuccess(response.data));
        dispatch(showInfo("已保存"));
      })
      .catch(error => {
        dispatch(_branchHeadCountDetailFailure("未能讀取"));
        dispatch(showErrorResponse(error));
      })
  };
}

export const deleteEntities = (history) => {
  return (dispatch, getState, x) => {
    const apiEndpoint = `${cfg.ApiOrigin == "window.location.origin" ? window.location.origin : cfg.ApiOrigin}/api/BranchHeadCount/DeleteEntities`;

    const { branchHeadCount: { workingEntities } } = getState();

    dispatch(showLoading());
    dispatch(_branchHeadCountRequest());

    axios.post(apiEndpoint, workingEntities, {
      timeout: 30000,
    })
      .then(response => {
        const { branchHeadCount: { filter } } = getState();

        dispatch(clearMsg());
        history.push('/branchHeadCount');
        dispatch(branchHeadCountLookup(filter));
      })
      .catch(error => {
        dispatch(_branchHeadCountDetailFailure("未能讀取"));
        dispatch(showErrorResponse(error));
      })
  };
}

//================== Reducer ==================//
const branchHeadCountReducer = (state = initialState, action) => {
  let _state = cloneDeep(state);

  switch (action.type) {
    case BranchHeadCountActions.FILTER_UPDATE:
      const { field: filterField, value } = action.payload;
      let filters = JSON.parse(state.filter.filter);
      const iFilter = _.findIndex(filters, function (o) { return o.property == filterField; });
      if (iFilter >= 0) {
        if (value) filters[iFilter].value = value;
        else filters.splice(iFilter, 1);
      } else {
        filters.push({ "property": filterField, "value": value });
      }

      _state.filter.filter = JSON.stringify(filters);
      _state.isFilterUpdated = true;
      //console.log('_state.filter', _state.filter.filter);
      return _state;

    case BranchHeadCountActions.CHANGE_SORT:
      const field = action.payload;
      let sorts = JSON.parse(state.filter.sort);
      const i = _.findIndex(sorts, function (o) { return o.property == field; });
      if (i >= 0) {
        sorts[i].direction = sorts[i].direction == "ASC" ? "DESC" : "ASC";
      } else {
        // single sort only
        sorts = [{ "property": field, "direction": "ASC" }];
      }

      _state.filter.sort = JSON.stringify(sorts);
      //console.log('_state.filter.sort', _state.filter.sort);

      branchHeadCountLookup(_state.filter);
      return _state;

    case BranchHeadCountActions.PAGE_UPDATE:
      _state.filter.page = action.payload;
      return _state;

    case BranchHeadCountActions.FETCH_PAGE:
      _state.filter.page = action.payload;
      return _state;

    case BranchHeadCountActions.REQUEST:
      _state.isLoading = true;
      return _state

    case BranchHeadCountActions.SUCCESS:
      _state.isLoading = false;
      _state.filter = {
        allRecords: action.payload.allRecords,
        matchedRecords: action.payload.matchedRecords,
        totalRecords: action.payload.totalRecords,
        qtyPerPage: action.payload.qtyPerPage,
        page: action.payload.page,
        row: action.payload.row,
        filter: action.payload.filter,
        sort: action.payload.sort,
        success: action.payload.success,
        message: action.payload.message,
      };
      _state.entities = action.payload.entities;
      _state.errors = "";
      _state.isFilterUpdated = false;
      return _state;

    case BranchHeadCountActions.FAILURE:
      _state.isLoading = false;
      _state.errors = action.payload;
      _state.entities = [];
      return _state;

    case BranchHeadCountActions.DETAIL_ID:
      _state.workingEntityId = action.payload;
      return _state;

    case BranchHeadCountActions.DETAIL_SUCCESS:
      _state.isLoading = false;
      _state.workingEntities = action.payload.map(c => new BranchHeadCount(c));
      return _state;

    case BranchHeadCountActions.DETAIL_FAILURE:
      _state.isLoading = false;
      return _state;

    case BranchHeadCountActions.DETAIL_UPDATE:
      const { index: updateIndex, fieldName: updateFieldName, value: updateValue } = action.payload;
      _state.workingEntities[updateIndex][updateFieldName] = updateValue;

      switch (updateFieldName) {
        case 'Fdate': // apply to all
          _.forEach(_state.workingEntities, function (branchHeadCount) {
            branchHeadCount.Fdate = updateValue;
          });
          break;
        case 'Tdate': // apply to all
          _.forEach(_state.workingEntities, function (branchHeadCount) {
            branchHeadCount.Tdate = updateValue;
          });
          break;
      }
      return _state;

    case BranchHeadCountActions.DETAILS_INIT:
      const Fdate = Moment.utc(action.payload).format('YYYY-MM-01');
      const Tdate = Moment.utc(action.payload).endOf('month').format('YYYY-MM-DD');
      console.log('Tdate', Tdate);

      _.forEach(_state.workingEntities, function (branchHeadCount) {
        branchHeadCount.Fdate = Fdate;
        branchHeadCount.Tdate = Tdate;
      });

      return _state;

    default:
      return state;
  }
}

export default branchHeadCountReducer;

